import { Component, OnInit } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"
import { UserService } from "../../../services/user.service"
import { ResourceService } from "../../../services/resource.service"
import { Resource } from "../../../models/resource/resource"
import { AddOnViewService } from "../../../services/add-on-view.service"

@Component({
    selector: "app-share-link-modal",
    templateUrl: "./share-link-modal.component.html",
    styleUrls: ["./share-link-modal.component.scss"],
    standalone: false,
})
export class ShareLinkModalComponent implements OnInit {
    focusLink: any
    fullViewLink: any
    focusViewLabel = "Focus View (distraction-free media view)"
    fullViewLabel = "Full Resource View"
    resourceIsVideo: boolean
    isAddonView: boolean

    constructor(
        public activeModal: ModalRef,
        public userService: UserService,
        public resourceService: ResourceService,
        public addOnService: AddOnViewService
    ) {}

    ngOnInit() {
        this.isAddonView = this.addOnService.isAddonView
        this.focusLink =
            window.location.host + window.location.pathname + "?student=true&focus=true"
        this.fullViewLink = window.location.host + window.location.pathname + "?student=true"
        this.resourceService.resourceResponse.subscribe((resource: Resource) => {
            this.resourceIsVideo = resource.opensAsVideo
        })
    }
}
